export default __webpack_public_path__ + "static/media/5.ac8ee96b.png";